import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import * as firebase from 'firebase';
import swal from 'sweetalert';
@Component({
  selector: 'app-priceuser',
  templateUrl: './priceuser.component.html',
  styleUrls: ['./priceuser.component.css']
})
export class PriceuserComponent implements OnInit {
  timerVar:any;

  price_sell
  price_low
  price_medium
  s


  photo_type_edit='';
  count_chat_show_1=0;
  count_warning_show_1=0;

  name_cate='';
  
  constructor(public db : AngularFireDatabase) { 

    this.startTimer2();

  }
  ngOnInit() {
    this.get_price();
  }
  get_price(){

    this.price_sell=0;
    this.price_low=0;
    this.price_medium=0;

    this.s = this.db.database.ref('differentmoney')
    this.s.on('child_added',snap=>{
      console.log(snap.val().category_user_select)
      console.log(snap.val().price)
      if(snap.val().category_user_select === "sell"){
        this.price_sell =snap.val().price
        console.log(this.price_sell)
      }
      if(snap.val().category_user_select === "buy_low"){
        this.price_low =snap.val().price
        console.log(this.price_low)
      }
      if(snap.val().category_user_select === "buy_medium"){
        this.price_medium =snap.val().price
        console.log(this.price_medium)
      }
    })

  }
  update_price(){

  }
  update_price_sell(){
    if(this.price_sell >0){

      swal({
        title: "คุณต้องการแก้ไขข้อมูล?",
        text: "ใช่หรือไม่",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          swal("แก้ไขข้อมูลสำเร็จ", {
            icon: "success",
          });
          let price_sell={
            price_sell :{
              category_user_select:'sell',
              price:this.price_sell
            }
          } 
          this.db.object('differentmoney').update(price_sell);
          console.log('save')   
             
        } else {
          swal("แก้ไขข้อมูลไม่สำเร็จ!");
        }
      });
      
    
    }else{
      swal("แจ้งเตือน!", "กรุณาป้อนข้อมูล!");
    }


      
  }
  update_price_low(){
    if(this.price_low >0){

      swal({
        title: "คุณต้องการแก้ไขข้อมูล?",
        text: "ใช่หรือไม่",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          swal("แก้ไขข้อมูลสำเร็จ", {
            icon: "success",
          });
          let price_low={
            price_low :{
              category_user_select:'buy_low',
              price:this.price_low
            }
          }
          this.db.object('differentmoney').update(price_low);
          console.log('save')  
             
        } else {
          swal("แก้ไขข้อมูลไม่สำเร็จ!");
        }
      });

    }else{
      swal("แจ้งเตือน!", "กรุณาป้อนข้อมูล!");
    }

  }
  update_price_medium(){
    if(this.price_medium >0){
      swal({
        title: "คุณต้องการแก้ไขข้อมูล?",
        text: "ใช่หรือไม่",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          swal("แก้ไขข้อมูลสำเร็จ", {
            icon: "success",
          });
          let price_medium={
            price_medium :{
              category_user_select:'buy_medium',
              price:this.price_medium
          }
      
        }
        this.db.object('differentmoney').update(price_medium);
          console.log('save')   
             
        } else {
          swal("แก้ไขข้อมูลไม่สำเร็จ!");
        }
      });
    }else{
      swal("แจ้งเตือน!", "กรุณาป้อนข้อมูล!");
    }
  }

  startTimer2(){
    this.timerVar = Observable.interval(1000).subscribe(x =>{
      this.get_count_warning();
      this.get_count_chat();
  
    })
  }
  get_count_warning(){
    var count_warning =0;
    
    this.s = this.db.database.ref('location').orderByChild('status_bill/value_bill').equalTo('on')
    this.s.on('child_added',snap=>{
      count_warning++;
  
      if(this.count_warning_show_1 <= count_warning){
        this.count_warning_show_1 = count_warning;
      }
      
    })
  
  }
  show_use(cate){
    if(cate==='sell'){
      this.name_cate = 'ผู้ที่ต้องการขายขยะรีไซเคิล'
    }else if(cate==='buy_low'){
      this.name_cate = 'ผู้ที่ต้องการซื้อ/ขายขยะรีไซเคิล'
    }else{
      this.name_cate = 'ผู้ที่ต้องการซื้อขยะรีไซเคิล'
    }

  }
  
  
  get_count_chat(){
  
    var count_chat=0;
    // // get ใส่ storage แล้วดึงมาเอา ให้ได้ทุกหน้าเลย
    // this.storage.get('count_chat').then((val)=>{
    //   this.count_chat_show_1 = val;
    // });
    this.s = this.db.database.ref('location/'+'admin_chat'+'/main_chat/chat_select').orderByChild('count_chat').equalTo('on');
    this.s.on('child_added',snap =>{
      count_chat++;
    
      if(this.count_chat_show_1 <= count_chat ){
        this.count_chat_show_1 = count_chat;
        // this.storage.set('count_chat',count_chat);
        
      }
  
    })
   }

  onFileChanged_edit(event){
     
  
    const file = event.target.files[0];
    console.log(file)
    const filename = Math.floor(Date.now() / 1000);  
    let storageRef = firebase.storage().ref()
    storageRef.child('images/' + filename).put(file)    
    .then(res => {
       res.ref.getDownloadURL().then(URLIMG=>{
        this.photo_type_edit = URLIMG;
        console.log('URLIMG : ',this.photo_type_edit)
       })
      }).catch(err => {
      
        alert("อัพโหลดภาพไม่สำเร็จ "+err);
      }); 
 }

 add_garbage_tpye(){
  this.db.list('phototop').push({
    photo: this.photo_type_edit,
  })
}

}
